export default __webpack_public_path__ + "static/media/web-development-selected.7ce37bd0.svg";